module.exports = __webpack_public_path__ + "img/gallery08.b13617cf.jpg";